export default __webpack_public_path__ + "static/media/pacific_beach.c832fb9b.jpeg";